import styled from 'styled-components';

export const StaffPageHeaderSearchDesktopInputsForm = styled.form<{
  $isTabbing?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
`;

export const StaffPageHeaderSearchDesktopInputsFieldsHolder = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 12px;
`;
